module.exports = __webpack_public_path__ + "img/pagination-left.618f7cb9.svg";